import { Component, Input } from '@angular/core';
import { InventoryRequisitionService, RequisitionFabric } from '../../../services/base-actions/inventory-requisition.service';
import { Business } from '../../../models/finance/business';
import { GroupedEntries } from '../../../models/yarn-requisition/yarn-requisition-form';

@Component({
  selector: 'app-yarns-group-details-panel',
  templateUrl: './yarns-group-details-panel.component.html',
  styleUrl: './yarns-group-details-panel.component.scss',
})
export class YarnsGroupDetailsPanelComponent {
  @Input() group!: GroupedEntries;
  @Input() index!: number;
  @Input() providersOptions: Business[] = [];

  selectedFabrics: RequisitionFabric[] = [];

  constructor(private inventoryRequisitionService: InventoryRequisitionService) {
    this.selectedFabrics = this.inventoryRequisitionService.selectedFabrics$();
  }

  calcRequiredItems(value: string, index: number) {
    this.inventoryRequisitionService.calcRequiredItems(value, index);
  }
}
